import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { KDSFetchSettings } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings';
export const DiningOptionConfiguration = ProtoBaseModel.extend({
  catalogObjectId: attr(String),
  selected: attr(Boolean),
  displayName: attr(String)
});
export const CategoryConfiguration = ProtoBaseModel.extend({
  catalogObjectId: attr(String),
  enabled: attr(Boolean),
  isKitchen: attr(Boolean),
  displayName: attr(String)
});
export const POSDeviceConfiguration = ProtoBaseModel.extend({
  deviceCredentialId: attr(String),
  displayName: attr(String),
  enabled: attr(Boolean),
  productType: attr(String)
});
export default ProtoBaseModel.extend({
  categories: repeated(CategoryConfiguration),
  uncategorizedEnabled: attr(Boolean),
  includeFutureCategoriesEnabled: attr(Boolean),
  ordersEnabled: attr(Boolean),
  displayOrderOnState: attr(KDSFetchSettings.DisplayOrderConfigurationState),
  stationOnPickupBufferSeconds: attr(Number),
  posEnabled: attr(Boolean),
  posDeviceConfigurations: repeated(POSDeviceConfiguration),
  includeFutureNamedPosEnabled: attr(Boolean),
  includeUnnamedPosEnabled: attr(Boolean),
  coursingDisplayType: attr(KDSFetchSettings.CoursingDisplayType),
  includeFutureDiningOptionsEnabled: attr(Boolean),
  diningOptionConfigurations: repeated(DiningOptionConfiguration),
  useSingleStationCompletion: attr(Boolean)
});